import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "styled-components";
import Switch from "../../common/Switch";
import Loading from "../../common/Loading";
import { useLive } from "../LiveProvider";
import { Container, Label, Control } from "./styled/live-listing-toggle";

function LiveListingToggle({ listingRecordId, label, loadingLabel, ...props }) {
  const theme = useTheme();
  const {
    visibleListings,
    isReportOwnedByCurrentAgent,
    toggleListing,
    isAddingListing
  } = useLive();
  const listing = visibleListings.find(
    (listing) => listing.recordId === listingRecordId
  );

  if (!isReportOwnedByCurrentAgent) return null;

  if (isAddingListing) {
    return (
      <Container {...props} isLoading>
        {loadingLabel && <Label>{loadingLabel}</Label>}
        <Control>
          <Loading />
        </Control>
      </Container>
    );
  }

  return (
    <Container>
      {label && <Label>{label}</Label>}
      <Control>
        <Switch
          {...props}
          color={theme.live.colors.primary}
          isOn={!listing ? false : !listing.isHidden}
          onChange={(_, e) => {
            e.stopPropagation();
            toggleListing(listingRecordId);
          }}
        />
      </Control>
    </Container>
  );
}

LiveListingToggle.defaultProps = {
  label: "Include Comp",
  loadingLabel: "Including Comp"
};

LiveListingToggle.propTypes = {
  listingRecordId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  label: PropTypes.string,
  loadingLabel: PropTypes.string
};

export default LiveListingToggle;
